module.exports = __webpack_public_path__ + "img/logo-um-fov.1683d9d1.png";